import { useParams } from 'react-router';

import NotFoundPage from 'components/NotFoundPage';

import JobOpeningLayout from './components/JobOpeningLayout';
import { meta as foundingMarketingLead } from './content/founding-marketing-lead';
import type { JobMeta } from './types';

// Explicitly import job content for reliable bundling
const jobs: JobMeta[] = [foundingMarketingLead];

export default function CareersPage() {
  const { slug } = useParams<{ slug: string }>();
  const job = jobs.find((j) => j.slug === slug);

  if (!job) {
    return <NotFoundPage />;
  }

  return <JobOpeningLayout meta={job} />;
}
